import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid, FormControl, InputLabel, Select, Input, MenuItem, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core'
import ro from 'date-fns/locale/ro';
// import en from 'date-fns/locale/en';
import Calendar from 'react-calendar';
import PropTypes from 'prop-types';



export default class BilanturiRows extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {

    }


    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    fullWidth={true}
                    fullScreen={true}
                    open={this.props.open}
                    onClose={this.props.dialogClose}>
                    <DialogActions >
                        <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i className='material-icons pm-round-button-text-dialog'>close</i>
                        </Fab>
                    </DialogActions>
                    <h2 className='pm-dialog-alert-title'>{this.props.strNume}</h2>

                    <Grid style={{width:'95%', margin:'10px auto'}} container className="pm-dialog-textfield-container" >

                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                            <TextField
                                className="inputFocus loginTextField"
                                style={{ width: '90%' }}
                                label='Descriere'
                                value={this.props.objRows.descriere || ''}
                                onChange={this.props.changeObj('descriere')}
                                margin="normal"
                                type='text'
                            />

                        </Grid>

                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                            <TextField
                                className="inputFocus loginTextField"
                                style={{ width: '90%' }}
                                label='Observatii'
                                value={this.props.objRows.obs || ''}
                                onChange={this.props.changeObj('obs')}
                                margin="normal"
                                type='text'
                            />
                        </Grid>

                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                            <TextField
                                className="inputFocus loginTextField"
                                style={{ width: '90%' }}
                                label='Nr Crt'
                                value={this.props.objRows.nr_crt || ''}
                                onChange={this.props.changeObj('nr_crt')}
                                margin="normal"
                                type='text'
                            />
                        </Grid>

                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                            <TextField
                                className="inputFocus loginTextField"
                                style={{ width: '90%' }}
                                label='Nr Rd'
                                value={this.props.objRows.nr_rd || ''}
                                onChange={this.props.changeObj('nr_rd')}
                                margin="normal"
                                type='text'
                            />
                        </Grid>

                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                            <TextField
                                className="inputFocus loginTextField"
                                style={{ width: '90%' }}
                                label='Sold Initial'
                                value={this.props.objRows.sold_initial || ''}
                                onChange={this.props.changeObj('sold_initial')}
                                margin="normal"
                                type='number'
                            />
                        </Grid>

                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                            <TextField
                                className="inputFocus loginTextField"
                                style={{ width: '90%' }}
                                label='Sold Final'
                                value={this.props.objRows.sold_final || ''}
                                onChange={this.props.changeObj('sold_final')}
                                margin="normal"
                                type='number'
                            />
                        </Grid>
                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                             <Button variant="outlined" onClick={this.props.addRow} className='pm-save-button'>
                            {this.props.limba.comune.add}
                        </Button>
                        </Grid>

                        <Grid style={{ textAlign: 'center', height:'90%', overflow:'auto' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                            {this.props.listRows.length > 0 &&

                                <Table style={{ width: '90%', margin: 'auto' }}>
                                    <TableHead>
                                        <TableRow >

                                            <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                                Descriere
                                            </TableCell>
                                            <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                                Observatii
                                            </TableCell>
                                            <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                                Nr Crt
                                            </TableCell>
                                            <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                                Nr Rd
                                            </TableCell>
                                            <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                                Sold Initial
                                            </TableCell>
                                            <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                                Sold Final
                                            </TableCell>


                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {this.props.listRows.map((l, idx) => {
                                            return (
                                                <TableRow style={{ cursor: 'pointer' }} key={idx}>
                                                    <TableCell style={{ textAlign: 'center' }}>
                                                        {l.descriere}
                                                    </TableCell>

                                                    <TableCell style={{ textAlign: 'center' }} >
                                                        {l.obs}
                                                    </TableCell>
                                                    <TableCell style={{ textAlign: 'center' }} >
                                                        {l.nr_crt}
                                                    </TableCell>
                                                    <TableCell style={{ textAlign: 'center' }} >
                                                        {l.nr_rd}
                                                    </TableCell>
                                                    <TableCell style={{ textAlign: 'center' }} >
                                                        {l.sold_initial}
                                                    </TableCell>
                                                    <TableCell style={{ textAlign: 'center' }} >
                                                        {l.sold_final}
                                                    </TableCell>
                                                    <TableCell style={{ textAlign: 'center' }} >
                                                        <i onClick={()=>{this.props.deleteRow(l)}} style={{color:'#dc2b2b'}} className='material-icons'>delete</i>
                                                    </TableCell>

                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            }
                        </Grid>

                    </Grid>

                


                </Dialog>
            </div>
        );
        }
    }
    
    //end class;

        BilanturiRows.propTypes={
            open:PropTypes.bool,
            dialogClose:PropTypes.func,
            strNume:PropTypes.string,
            objRows:PropTypes.object,
            changeObj:PropTypes.func,
            addRow:PropTypes.func,
            limba:PropTypes.object,
            listRows:PropTypes.array
        
        }
